<template>
  <div>
    <button
      v-for="(paymentMethod, key) in methods"
      :key="key"
      :disabled="!hasAgreed"
      :class="{ 'bg-primary': selectedPaymentMethod == paymentMethod.key }"
      class="w-40 h-24 p-3 bg-gradient-to-b from-[5%] aspect-square rounded flex justify-center items-center flex-col gap-4 bg-brand-gray-600 disabled:bg-brand-gray-300 hover:bg-primary-700/40"
      @click="$emit('onSelection', paymentMethod.key)"
    >
      <div class="w-auto h-7">
        <img
          v-if="paymentMethod.titleIcon"
          :src="paymentMethod.titleIcon"
          :alt="paymentMethod.label"
          class="w-auto h-9"
        />
      </div>
      <div class="flex gap-x-2 items-center">
        <img
          v-if="paymentMethod.icon"
          :src="paymentMethod.icon"
          :alt="paymentMethod.label"
          class="w-auto h-5"
        />
        <span class="pt-0.5 text-xs text-white ltr:font-sans">{{ $t(paymentMethod.label) }}</span>
      </div>
    </button>
  </div>
</template>

<script setup>
import amwalLogo from '@/assets/pngs/amwal-logo-en.png'
import amwalWallet from '@/assets/pngs/amwal-wallet.png'
import payLater from '@/assets/pngs/paylater.png'

defineProps({
  hasAgreed: Boolean,
  selectedPaymentMethod: String
})

const methods = [
  {
    key: 'eWallet',
    titleIcon: amwalLogo,
    label: 'payByAmwal',
    icon: amwalWallet,
    onClickFunc: () => {}
  },
  {
    key: 'creditCard',
    titleIcon: amwalLogo,
    label: 'payByCreditCard',
    icon: amwalWallet,
    onClickFunc: () => {}
  },
  {
    key: 'payLater',
    titleIcon: payLater,
    label: 'payLater',
    onClickFunc: () => {}
  }
]
</script>

<style lang="scss" scoped></style>
